function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.46905 8.53094C9.54867 8.53094 11.2345 6.84509 11.2345 4.76547C11.2345 2.68586 9.54867 1 7.46905 1C5.38944 1 3.70358 2.68586 3.70358 4.76547C3.70358 6.84509 5.38944 8.53094 7.46905 8.53094Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 16.0619C1 13.1475 3.89941 10.7903 7.46908 10.7903C8.19205 10.7903 8.89243 10.8882 9.54763 11.0689",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13.0495C15 13.6143 14.8419 14.149 14.5632 14.6009C14.4051 14.872 14.2017 15.113 13.9683 15.3088C13.4411 15.7832 12.7482 16.0619 11.9876 16.0619C10.8881 16.0619 9.93166 15.4744 9.41203 14.6009C9.13338 14.149 8.97524 13.6143 8.97524 13.0495C8.97524 12.1006 9.41204 11.2496 10.1049 10.6998C10.6245 10.2856 11.2797 10.0371 11.9876 10.0371C13.652 10.0371 15 11.3851 15 13.0495Z",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8128 13.0495L11.5583 13.7951L13.1624 12.3115",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.9d2bc46eda7d65cf68918edbd46cf1ac.svg";
export { ForwardRef as ReactComponent };